import React from 'react';
import { Sparkles, MessageCircle, MapPin, Phone, Mail } from 'lucide-react';
import { contactInfo } from '../mock';
import { useT } from '../i18n/LanguageContext';

export default function Footer() {
  const { t } = useT();

  const navLinks = [
    { label: t('nav.home'), href: '#home' },
    { label: t('nav.services'), href: '#services' },
    { label: t('nav.areas'), href: '#areas' },
    { label: t('nav.faq'), href: '#faq' },
    { label: t('nav.contact'), href: '#contact' },
  ];

  return (
    <footer className="bg-[#12183a] text-white/85">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src="/logo/gicleanly-logo.jpg"
              alt="GiCleanly"
              className="w-11 h-11 rounded-full object-cover"
            />
            <div className="leading-tight">
              <p className="font-serif text-xl font-bold text-white">GiCleanly</p>
              <p className="text-[10px] tracking-[.22em] uppercase text-[#7fe0ce] -mt-1">Clean Spaces, Deep Clear</p>
            </div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed">{t('footer.tagline')}</p>
          <div className="flex gap-3 mt-5">
            <a
              href="https://wa.me/447547340708?text=Hi%20GiCleanly!%20I%27d%20like%20to%20book%20a%20cleaning%20service."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#25D366] hover:bg-[#1fbd5a] text-white text-sm font-semibold transition-colors"
              aria-label="Chat on WhatsApp"
            >
              <MessageCircle size={16} fill="white" strokeWidth={0} />
              {t('footer.chatWA')}
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-semibold text-white mb-4 uppercase tracking-wider text-sm">{t('footer.company')}</h4>
          <ul className="space-y-2">
            {navLinks.map((l) => (
              <li key={l.label}>
                <a href={l.href} className="text-sm text-white/70 hover:text-[#7fe0ce] transition-colors">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-white mb-4 uppercase tracking-wider text-sm">{t('footer.services')}</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li>{t('footer.residential')}</li>
            <li>{t('footer.commercial')}</li>
            <li>{t('footer.endTenancy')}</li>
            <li>{t('footer.deep')}</li>
            <li>{t('footer.carpet')}</li>
            <li>{t('footer.postConst')}</li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-white mb-4 uppercase tracking-wider text-sm">{t('footer.getInTouch')}</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex gap-3">
              <MapPin size={16} className="shrink-0 mt-1 text-[#7fe0ce]" />
              <span>{contactInfo.address}</span>
            </li>
            <li className="flex gap-3 items-center">
              <Phone size={16} className="shrink-0 text-[#7fe0ce]" />
              <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="hover:text-white transition-colors">{contactInfo.phone}</a>
            </li>
            <li className="flex gap-3 items-center">
              <Mail size={16} className="shrink-0 text-[#7fe0ce]" />
              <a href={`mailto:${contactInfo.email}`} className="hover:text-white transition-colors">{contactInfo.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/60">
            © {new Date().getFullYear()} GiCleanly. {t('footer.rights')}
          </p>
          <div className="flex gap-6 text-xs text-white/60">
            <a href="#" className="hover:text-white transition-colors">{t('footer.privacy')}</a>
            <a href="#" className="hover:text-white transition-colors">{t('footer.terms')}</a>
            <a href="#" className="hover:text-white transition-colors">{t('footer.cookies')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
